import { UseQueryResult, useQuery } from 'react-query'

import { QueryKey } from '@/configs/queryKeys'
import {
  ILogisticItems,
  ILogisticItemsList,
  ILogisticsDetail,
  ILogisticStatusList
} from '@/interfaces/logistics'
import {
  getLogistic,
  GetLogistic,
  getLogisticList,
  getLogisticStatusList
} from '@/services/logistics'

export function useGetLogisticsList({
  page,
  pageSize,
  groupNumber,
  rastreioApi,
  search
}: {
  page: number
  pageSize: number
  groupNumber: string
  search: string
  rastreioApi?: boolean
}): UseQueryResult<ILogisticItems> {
  return useQuery(
    [QueryKey.logisticList, { page, pageSize, groupNumber, search, rastreioApi }],
    getLogisticList,
    {
      keepPreviousData: true,
      suspense: true
    }
  )
}

export function useGetLogisticItem(
  groupNumber: string,
  rastreioApi?: boolean
): UseQueryResult<ILogisticsDetail> {
  return useQuery([QueryKey.logistic, { groupNumber, rastreioApi }], GetLogistic, {
    enabled: Boolean(groupNumber)
  })
}

export function useGetStatusList(): UseQueryResult<ILogisticStatusList[]> {
  return useQuery([QueryKey.logisticStatusList], getLogisticStatusList, {
    keepPreviousData: true
  })
}

export function useGetLogistics({
  params
}: {
  params: {
    page: number
    ItemsPerPage: number
    AccountId?: string | undefined
    DeliveryStatus?: string | undefined
    StartSalesOrderCreatedOn?: string | undefined
    EndSalesOrderCreatedOn?: string | undefined
    Address?: string | undefined
    BranchCnpj?: string | undefined
    OrderNumber?: string | undefined
    Package?: string | undefined
    Cpf?: string | undefined
  }
}): UseQueryResult<ILogisticItemsList> {
  return useQuery([QueryKey.logisticListItems, { params }], getLogistic, {
    keepPreviousData: false,
    retry: false
  })
}
